import t from "prop-types";


import { css } from "@emotion/react";

const propTypes = {
  children: t.oneOfType([t.element, t.arrayOf(t.element)]).isRequired,
};

const rootStyle = css`
  width: 24px;
  height: 24px;
  > svg {
    width: 24px;
    height: 24px;
    fill: none !important;
  }
`;

const StreamlineIconWrapper = (props) => {
  const { children } = props;
  return (
    <span css={rootStyle}>
      {children}
    </span>
  );
};

StreamlineIconWrapper.propTypes = propTypes;

export default StreamlineIconWrapper;
